/*
  SSP PDX wear test: "Meet your pilot sock".
  Port of the new-features-page script. Links the sock diagram to the
  feature cards: every hotspot (desktop), circle (mobile) and card in a
  [data-ssp-pdx-features] root carries a data-index, and activating one adds
  .is-active to all three.
  - desktop: hovering a hotspot or card lights up its partner
  - tapping a circle scrolls its card into view; tapping a card on mobile
    scrolls back up to the image
  Without this file the image, hotspots and cards still render; they just
  aren't linked.
*/
(function () {
  if (window.sspPdxFeaturesReady) return;
  window.sspPdxFeaturesReady = true;

  var mobile = window.matchMedia('(max-width: 768px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehavior() {
    return reducedMotion.matches ? 'auto' : 'smooth';
  }

  function init(root) {
    if (root.sspPdxReady) return;
    root.sspPdxReady = true;

    var hotspots = root.querySelectorAll('.ssp-pdx__hotspot');
    var circles = root.querySelectorAll('.ssp-pdx__circle');
    var cards = root.querySelectorAll('.ssp-pdx__fcard');
    var image = root.querySelector('.ssp-pdx__features-image');

    // A card can cover more than one spot ("5,6"); hotspots and circles have one
    function indicesOf(el) {
      return (el.getAttribute('data-index') || '').split(',');
    }

    function matching(list, indices) {
      return Array.prototype.filter.call(list, function (el) {
        return indicesOf(el).some(function (i) { return indices.indexOf(i) !== -1; });
      });
    }

    // A spot lights up its card and every other spot that card covers
    function indicesForSpot(index) {
      var card = matching(cards, [index])[0];
      return card ? indicesOf(card) : [index];
    }

    function clearAll() {
      root.querySelectorAll('.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
    }

    function activate(indices) {
      clearAll();
      matching(hotspots, indices)
        .concat(matching(circles, indices), matching(cards, indices))
        .forEach(function (el) { el.classList.add('is-active'); });
    }

    function isHovered(indices) {
      return matching(hotspots, indices)
        .concat(matching(cards, indices))
        .some(function (el) { return el.matches(':hover'); });
    }

    // Clear on leave unless the pointer moved to a partner element
    function onLeave(indices) {
      setTimeout(function () {
        if (!isHovered(indices)) clearAll();
      }, 50);
    }

    // Desktop hover (checked on each event, so resizing keeps working)
    Array.prototype.forEach.call(hotspots, function (el) {
      var index = indicesForSpot(el.getAttribute('data-index'));
      el.addEventListener('mouseenter', function () {
        if (!mobile.matches) activate(index);
      });
      el.addEventListener('mouseleave', function () {
        if (!mobile.matches) onLeave(index);
      });
      el.addEventListener('focus', function () { activate(index); });
      el.addEventListener('click', function () { activate(index); });
    });

    Array.prototype.forEach.call(cards, function (card) {
      var index = indicesOf(card);
      card.addEventListener('mouseenter', function () {
        if (!mobile.matches) activate(index);
      });
      card.addEventListener('mouseleave', function () {
        if (!mobile.matches) onLeave(index);
      });
      card.addEventListener('click', function () {
        activate(index);
        if (mobile.matches && image) {
          image.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
        }
      });
    });

    // Mobile circles: activate and bring the card into the swipe row
    Array.prototype.forEach.call(circles, function (circle) {
      var index = indicesForSpot(circle.getAttribute('data-index'));
      circle.addEventListener('click', function () {
        activate(index);
        var card = matching(cards, index)[0];
        if (!card) return;
        var row = card.parentElement;
        var left = card.offsetLeft - row.offsetLeft - (row.clientWidth - card.offsetWidth) / 2;
        row.scrollTo({ left: Math.max(0, left), behavior: scrollBehavior() });
        row.scrollIntoView({ behavior: scrollBehavior(), block: 'nearest' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ssp-pdx-features]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-renders the section without reloading the page
  document.addEventListener('shopify:section:load', initAll);
})();
